import style from './workout-list-page.module.scss'
import { useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import { PageContainer } from 'src/component/page-container/page-container'
import { BackArrow } from 'src/component/programmes/programme-back-arrow'
import { WorkoutPopup } from 'src/component/programmes/programme-workout-popup'
import { PaginationControls } from 'src/component/ui/pagination-controls'
import { WorkoutCard } from 'src/component/ui/workout-card'
import { WorkoutCardSkeleton } from 'src/component/ui/workout-card/workout-card-skeleton'
import { useSessionContext } from 'src/context/session-context'
import { Workout } from 'src/dao/core-dao'

export type WorkoutListPageProps = {
  title?: string
  workouts?: Workout[]
  isLoading?: boolean
  page?: number
  totalPages?: number
  onPageChange?: (page: number) => void
}
export const WorkoutListPage = ({
  title,
  workouts,
  isLoading,
  page,
  totalPages,
  onPageChange,
}: WorkoutListPageProps): React.ReactElement => {
  const [selectedWorkout, setSelectedWorkout] = useState<Workout | undefined>(undefined)
  const { completedWorkoutIds } = useSessionContext()
  const isEmpty = !isLoading && workouts !== undefined && workouts.length === 0
  const hasPagination = page !== undefined && totalPages !== undefined && onPageChange !== undefined

  return (
    <PageContainer>
      <div className={`mt-5${hasPagination ? ' pb-5' : ''}`}>
        <Row className="mb-10">
          <BackArrow />
        </Row>
        <Row className="mb-10">
          <h1 className="font-evogria font-normal text-[57px] leading-[64px] flex items-center tracking-[-0.25px] text-primary flex-none grow-0 uppercase">
            {title}
          </h1>
        </Row>
        <Row>
          {isLoading &&
            Array.from({ length: 9 }).map((_, index) => (
              <Col key={index} lg={4} className="mb-6">
                <WorkoutCardSkeleton />
              </Col>
            ))}
          {isEmpty && <p className={style.noWorkoutsLabel}>No Workouts Found</p>}
          {!isLoading &&
            workouts &&
            workouts.length > 0 &&
            workouts.map((w) => (
              <Col key={w.id} lg={4} className="mb-6">
                <WorkoutCard.List
                  workout={w}
                  isCompleted={completedWorkoutIds.has(w.id)}
                  onAction={() => setSelectedWorkout(w)}
                />
              </Col>
            ))}
        </Row>
        {!isEmpty && hasPagination && (
          <PaginationControls page={page} totalPages={totalPages} onPageChange={onPageChange} className="mt-4" />
        )}
      </div>
      <WorkoutPopup
        setOnClose={() => setSelectedWorkout(undefined)}
        selectedWorkout={selectedWorkout}
        startWorkoutLink={selectedWorkout ? `/workouts/${selectedWorkout?.id}` : undefined}
      />
    </PageContainer>
  )
}
